<template>
  <div class="demand-detail">
    <DemandDetailPurchaser v-if="role == 'purchase'"></DemandDetailPurchaser>
    <DemandDetailSupplier v-if="role == 'supplier'"></DemandDetailSupplier>
  </div>
</template>

<script>
import DemandDetailPurchaser from "./DemandDetailPurchaser.vue";
import DemandDetailSupplier from "./DemandDetailSupplier.vue";
export default {
  name: "DemandDetail",
  components: {
    DemandDetailPurchaser,
    DemandDetailSupplier,
  },
  data() {
    return {
      role: "", // supplier=供应商,purchase=采购方
    };
  },
  mounted() {
    this.role = localStorage.getItem("role");
  },
};
</script>
